module.exports = __webpack_public_path__ + "static/img/partner18.5f7233d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner18.png
// module id = cFGJ
// module chunks = 0